module.exports = __webpack_public_path__ + "img/1.d36f4472.png";